import { render, staticRenderFns } from "./RsaStoricoPostoLettoViewComponent.vue?vue&type=template&id=4f1a872d&scoped=true"
import script from "./RsaStoricoPostoLettoViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaStoricoPostoLettoViewComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaStoricoPostoLettoViewComponent.vue?vue&type=style&index=0&id=4f1a872d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1a872d",
  null
  
)

export default component.exports